import api from '@/lib/api.js';
import $, { data } from 'jquery';
import _, { initial } from 'lodash';
import { add, i } from 'mathjs';
import nanoid from 'nanoid';
import findDangles from '@/lib/find-dangles.js';

var store = {
	namespaced: true,

	state: {
		interval: 500,
		limit: 10,
		updateQueue: [],
		historyQueue: []
	},

	getters: {
		updateQueue: function(state) {
			return state.updateQueue;
		}
	},

	mutations: {
		UPDATE_QUEUE: function(state, item) {
			state.updateQueue.push(item);
			//state.historyQueue.push(item);
		},
		UNDO: function(state) {
			state.undoQueue.pop();
		},
		CLEAR_QUEUE: function(state) {
			state.updateQueue = [];
		}
	},

	actions: {
		init(store) {
			setInterval(() => {
				store.dispatch('runTurnstile');
			}, store.state.interval);
		},

		async runTurnstile(store) {
			if (store.state.updateQueue.length > 0) {
				let arr = store.state.updateQueue;
				api.transactions.run(arr);
				store.commit('CLEAR_QUEUE');

				let blocks = store.rootGetters['block/blocks'];
				let obj = findDangles(store.rootGetters['block/rootBlock']._id, blocks);

				console.log(obj);
			}
		},

		trackEvent: function(store, obj) {
			let name = obj.name;
			let payload = obj.payload;

			let data = {};

			if (name === 'block/bulkDeleteBlocks') {
				data.blocks = payload.length;
			}

			if (name === 'block/bulkAddBlocks') {
				data.blocks = payload.length;
			}

			if (name === 'block/bulkUpdateBlocks') {
				data.blocks = payload.length;
			}

			let response = {
				name,
				data
			};

			store.dispatch(
				'event/trackEvent',
				{
					name: name,
					data: data
				},
				{ root: true }
			);
		},

		/**
		 * You can pass an array just to make batching actions easier
		 */
		async add(store, arr) {
			for (let i = 0; i < arr.length; i++) {
				let name = arr[i].name;
				let payload = arr[i].payload;
				let obj = {
					name: name,
					payload: payload,
					_id: nanoid(),
					complete: false
				};

				// track events
				store.dispatch('trackEvent', obj);

				// Update state ofc
				store.commit('UPDATE_QUEUE', obj);
			}
		}
	}
};

export default store;
